var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"transition duration-300 hover:text-yellow-400 dark:hover:text-yellow-300",attrs:{"aria-label":_vm.label,"href":_vm.link}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }